import React from 'react';
import IntroSection from '../../../component/introSection';
import QnASection from '../../home/component/QnASection';
import { useMobile } from '../../../hook/usePlatform';
import { FontWeightType } from '../../../component/Text';
import { lineColor } from '../../../util/colors';

const RequestConsult:React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;
  return (
    <div
      id="consult"
    >
      <IntroSection
        title="[상담하기]"
        content={'늦은 시작은 없습니다.\n지금, 시럽 인연과 함께 하세요'}
      />
      <div style={{ borderBlock: border }}>
        <QnASection />
      </div>
      {!isMobile ? (
        <IntroSection
          title=""
          contentStyle={{ fontWeight: FontWeightType.w800 }}
          content={'혼자여서 힘들었던 순간들,\n이제 함께 나누며 따뜻한 내일을 만들어갑니다'}
        />
      ) : null}
    </div>
  );
};

export default RequestConsult;
